import { Alert } from "@xola/ui-kit";
import React from "react";
import { AlertModal } from "../Common/GenericTextModal";

interface PaymentFailedAlertModalProps {
    error?: string | null;
    onConfirm: () => void;
}

export const PaymentFailedAlertModal = ({ error, onConfirm }: PaymentFailedAlertModalProps) => {
    return (
        <AlertModal isOpen={!!error} title="Error Charging Card" confirmText="Close" onConfirm={onConfirm}>
            <div className="space-y-4">
                <div>We were unable to charge your card. The following reason was given by our payment processor:</div>

                {error ? <Alert color="danger">{error}</Alert> : null}

                <div>
                    Please try another card or have the customer contact the issuing bank using the phone number located
                    on the back of the card.
                </div>
            </div>
        </AlertModal>
    );
};
